import { FormDialog } from '../../../components/ui/FormDialog';
import { Badge } from '../../../components/ui/Badge';
import { str } from '../../../platform/api/utils';
import {
  Dd,
  Dt,
  STATUS_LABELS,
  STATUS_VARIANTS,
  TYPE_LABELS,
  VISIBILITY_LABELS,
  dlGrid,
  formatDate,
  formatTime,
  inputCss,
  primaryBtn,
  secondaryBtn,
} from './calendar-page.support';

export function CalendarCreateModal(props: {
  newTitle: string;
  setNewTitle: (v: string) => void;
  newDate: string;
  setNewDate: (v: string) => void;
  newType: string;
  setNewType: (v: string) => void;
  visibleInMemberApp: boolean;
  setVisibleInMemberApp: (v: boolean) => void;
  requirePresence: boolean;
  setRequirePresence: (v: boolean) => void;
  startTime: string;
  setStartTime: (v: string) => void;
  endTime: string;
  setEndTime: (v: string) => void;
  error: string;
  createPending: boolean;
  onCancel: () => void;
  onCreate: () => void;
}) {
  const {
    newTitle,
    setNewTitle,
    newDate,
    setNewDate,
    newType,
    setNewType,
    visibleInMemberApp,
    setVisibleInMemberApp,
    requirePresence,
    setRequirePresence,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    error,
    createPending,
    onCancel,
    onCreate,
  } = props;
  return (
    <FormDialog title="Novo evento" onClose={onCancel} busy={createPending}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <label>
          Título da atividade
          <input
            value={newTitle}
            onChange={(e) => {
              setNewTitle(e.target.value);
            }}
            placeholder="Título do evento"
            style={inputCss}
          />
        </label>
        <label>
          Data
          <input
            type="date"
            value={newDate}
            onChange={(e) => {
              setNewDate(e.target.value);
            }}
            style={inputCss}
          />
        </label>
        <label>
          Início
          <input
            type="time"
            value={startTime}
            onChange={(e) => {
              setStartTime(e.target.value);
            }}
            style={inputCss}
          />
        </label>
        <label>
          Fim
          <input
            type="time"
            value={endTime}
            onChange={(e) => {
              setEndTime(e.target.value);
            }}
            style={inputCss}
          />
        </label>
        <label>
          Tipo de atividade
          <select
            value={newType}
            onChange={(e) => {
              setNewType(e.target.value);
            }}
            style={inputCss}
          >
            {Object.entries(TYPE_LABELS).map(([k, v]) => (
              <option key={k} value={k}>
                {v}
              </option>
            ))}
          </select>
        </label>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: '0.85rem',
            color: 'var(--muted)',
          }}
        >
          <input
            type="checkbox"
            checked={visibleInMemberApp}
            onChange={(e) => {
              setVisibleInMemberApp(e.target.checked);
            }}
          />
          Visível no app do membro
        </label>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: '0.85rem',
            color: 'var(--muted)',
          }}
        >
          <input
            type="checkbox"
            checked={requirePresence}
            onChange={(e) => {
              setRequirePresence(e.target.checked);
            }}
          />
          Exigir confirmação de presença
        </label>
        {error && <p role="alert">{error}</p>}
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button disabled={createPending} onClick={onCancel} style={secondaryBtn}>
            Cancelar
          </button>
          <button
            onClick={onCreate}
            disabled={createPending || !newTitle.trim() || !newDate}
            style={primaryBtn}
          >
            {createPending ? 'Criando...' : 'Criar'}
          </button>
        </div>
      </div>
    </FormDialog>
  );
}

export function CalendarDetailModal(props: {
  event: Record<string, unknown>;
  onClose: () => void;
}) {
  const { event, onClose } = props;
  return (
    <FormDialog title={str(event.title)} onClose={onClose}>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <Badge
          label={STATUS_LABELS[str(event.status)] ?? str(event.status)}
          variant={STATUS_VARIANTS[str(event.status)] ?? 'default'}
        />
        <Badge
          label={VISIBILITY_LABELS[str(event.visibility)] ?? str(event.visibility)}
          variant="info"
        />
      </div>
      <dl style={dlGrid}>
        <Dt>Tipo</Dt>
        <Dd>{TYPE_LABELS[str(event.type)] ?? '—'}</Dd>
        <Dt>Data</Dt>
        <Dd>{formatDate(event.startsAt)}</Dd>
        <Dt>Horário</Dt>
        <Dd>
          {formatTime(event.startsAt)} - {formatTime(event.endsAt)}
        </Dd>
        <Dt>App do membro</Dt>
        <Dd>{event.visibleInMemberApp ? 'Visível' : 'Não visível'}</Dd>
        <Dt>Confirmação de presença</Dt>
        <Dd>{event.requirePresenceConfirmation ? 'Exigida' : 'Não exigida'}</Dd>
        {str(event.location) && (
          <>
            <Dt>Local</Dt>
            <Dd>{str(event.location)}</Dd>
          </>
        )}
        {str(event.description) && (
          <>
            <Dt>Descrição</Dt>
            <Dd>{str(event.description)}</Dd>
          </>
        )}
      </dl>
      <div
        style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1rem' }}
      >
        <button onClick={onClose} style={secondaryBtn}>
          Fechar
        </button>
      </div>
    </FormDialog>
  );
}
